<script>
import moment from 'moment';

export default {
  name: 'ReadIndicator',
  props: {
    guests: {
      type: Array,
      default: () => [],
    },
    lastMessagesRead: {
      type: Array,
      default: () => [],
    },
    sentDate: {
      type: Date,
      required: true,
    },
    messageId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showPopover: false,
      popoverStyle: {},
    };
  },
  computed: {
    readStatuses() {
      return this.guests.map((guest) => {
        const read = this.lastMessagesRead.find((r) => r.participantId === guest.id && r.messageId === this.messageId);
        const isRead = !!read;
        return {
          id: guest.id,
          name: guest.name,
          isRead,
          dateRead: isRead ? moment.utc(read.readValue).local() : null,
        };
      });
    },
    isRead() {
      return this.readStatuses.length > 0 && this.readStatuses.every((r) => r.isRead);
    },
    isPartiallyRead() {
      return this.readStatuses.some((r) => r.isRead) && !this.isRead;
    },
  },
  methods: {
    formatDateRead(m) {
      return m.format('DD MMM [à] HH[h]mm');
    },
    updatePopoverPosition() {
      const rect = this.$refs.trigger.getBoundingClientRect();
      const popoverWidth = 220;
      const left = Math.min(Math.max(rect.right - popoverWidth, 8), window.innerWidth - popoverWidth - 8);
      this.popoverStyle = {
        left: `${left}px`,
        bottom: `${window.innerHeight - rect.top + 8}px`,
      };
    },
    onMouseEnter() {
      this.updatePopoverPosition();
      this.showPopover = true;
    },
  },
};
</script>

<template>
  <div ref="trigger" class="relative flex items-center" @mouseenter="onMouseEnter" @mouseleave="showPopover = false">
    <i class="ga-icon ga-check text-md" :class="isRead ? 'text-secondary' : 'text-grey-300'" />
    <i
      class="ga-icon ga-check text-md -ml-2.5"
      :class="isRead || isPartiallyRead ? 'text-secondary' : 'text-grey-300'" />
    <Teleport to="body">
      <div
        v-if="showPopover"
        class="fixed bg-white rounded-xl shadow-[0_4px_16px_rgba(0,0,0,0.08)] border border-grey-100 min-w-[220px] z-50 p-3 flex flex-col gap-1"
        :style="popoverStyle">
        <span class="text-[13px] font-medium text-grey-600 mb-1">Lu par</span>
        <div v-for="status in readStatuses" :key="status.id" class="flex items-center justify-between gap-3 text-sm">
          <span class="font-medium text-sm text-grey-900 truncate">{{ status.name }}</span>
          <span class="text-sm font-medium whitespace-nowrap text-grey-500">
            {{ status.isRead ? formatDateRead(status.dateRead) : 'Non lu' }}
          </span>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<style scoped></style>
